import { store, getContext } from '@wordpress/interactivity';

const { actions } = store( 'mag-extension-search', {
    actions: {
        toggleSearch( e ){
            let context = getContext();
            context.open = !context.open;
        }
    },
} );